<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Hours tracking report'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getTableFilters"
            :isLoading="isDataPageLoading"
            :data-changes="true"
            @submit="setFilterData"
          />

          <TableForHoursTrackingReport
            :current-week="week"
            :members="getMembersFilterData"
            :managers="getManagers"
            :disabled-btn="currentWeek"
            :total-data="getTotalData"
            :isDataLoading="isDataPageLoading"
            @dataChanged="dataChanged()"
            @changeWeek="changeCurrentWeek($event)"
            @getUserInfo="getReport"
          />
          <div
            class="table__theme-default mt-5"
          >
            <div class="table-container" v-if="!showPreloader && totalSpentTime.length">
              <table class="table b-table table-hover b-table-fixed">
                <thead>
                  <tr>
                    <th
                      v-for="(field) in fieldsPeople"
                      :key="field.key"
                      scope="col"
                      :class="field.key === 'name' && 'th-name'"
                    >{{ field.label }}
                    </th>
                    <th
                      v-for="(spentTime) in totalSpentTime"
                      :key="spentTime.date"
                      scope="col"
                      class="th-else"
                    >{{ spentTime.date }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(report, index) in reportsByUsers" :key="report.user.jira_user_name">
                    <td scope="col" class="cursor-pointer" v-b-tooltip.html="{ variant: 'base' }" :title="createUserTooltip(report)">
                      <TableUserItem :user="report.user" :number="index" :user-tooltip="false"/>
                    </td>

                    <template v-for="(spentTimeUser) in totalSpentTime">
                      <template v-if="getReportDateAttribute(report, spentTimeUser.date_format, 'spent_time_seconds') || isSickOrVacationDay(report.user.jira_user_name, spentTimeUser.date_format)">
                        <td
                          scope="col"
                          :title="getStringFromStartEndSpentTime(getReportDateAttribute(report, spentTimeUser.date_format, 'working_time'))"
                          :key="spentTimeUser.date_format"
                          :class = "(spentTimeUser.date_format != 'total'
                                      ? ('working-day-' + getWorkingDay(report.user.jira_user_name, spentTimeUser.date_format)
                                        + (isPartTimeDay(report, spentTimeUser.date_format) && !isSickOrVacationDay(report.user.jira_user_name, spentTimeUser.date_format) ? ' working-day-part-time' : ''))
                                      : '')"
                          @click="$bvModal.show('bv-modal-' + report.user.jira_user_name + '_' + spentTimeUser.date_format)"
                        >
                          <div class="spent-time cursor-pointer">
                            <span class="p-1">{{getReportDateAttribute(report, spentTimeUser.date_format, 'spent_time')}}</span>
                            <span class="material-icons icon-image-preview"
                                  v-if="isReportedDay(report, spentTimeUser.date_format)">done_all</span>
                            <span class="material-icons icon-image-preview"
                                  v-else-if="isCommentedDay(report, spentTimeUser.date_format)">done</span>
                          </div>
                        </td>
                      </template>
                      <template v-else>
                        <td
                          scope="col"
                          :title="report.dates[spentTimeUser.date_format] ? getStringFromStartEndSpentTime(getReportDateAttribute(report, spentTimeUser.date_format, 'working_time')) : []"
                          :class = "isWorkingDay(report.user.jira_user_name, spentTimeUser.date_format) ? 'working-day-part-time' : 'working-day-' + getWorkingDay(report.user.jira_user_name, spentTimeUser.date_format)"
                          :key="spentTimeUser.date_format"
                        >
                          <div class="spent-time">
                            {{ (isWorkingDay(report.user.jira_user_name, spentTimeUser.date_format) || (spentTimeUser.date_format == 'total')) ? '0' : '-'}}
                          </div>
                        </td>
                      </template>
                      <b-modal
                        :id="'bv-modal-' + report.user.jira_user_name + '_' + spentTimeUser.date_format"
                        :key="report.user.jira_user_name + '_' + spentTimeUser.date_format"
                        :title="getDayTypeName(report, spentTimeUser.date_format)"
                        size="lg"
                      >
                        <div data-v-0863bb5e="" class="table_theme-info">
                          <div v-if="isSickOrVacationDay(report.user.jira_user_name, spentTimeUser.date_format)">
                            <span v-if="isSickDay(report.user.jira_user_name, spentTimeUser.date_format)">Sick day is marked as reported</span>
                            <span v-if="isVacationDay(report.user.jira_user_name, spentTimeUser.date_format)">Vacation day is marked as reported</span>
                          </div>
                          <template v-else>
                            <div v-if="!checkEmpty(getReportDateAttribute(report, spentTimeUser.date_format, 'worklogs'))">No information</div>
                            <div
                            v-for="(worklog, index) in getReportDateAttribute(report, spentTimeUser.date_format, 'worklogs')"
                            :key="index">

                              <a target="_blank" :href="`https://giraffesoftware.atlassian.net/browse/${worklog['project_key']}`">{{worklog['project_name']}}</a>&nbsp;
                              <a target="_blank" :href="`https://giraffesoftware.atlassian.net/browse/${worklog['issue_key']}`"
                              >{{worklog['issue_key']}} {{worklog['spent']}}h</a>: <span v-html="isCommentedDay(report, spentTimeUser.date_format) ? worklog['comment'] : 'no comments added'"></span>
                            </div>
                          </template>

                        </div>
                        <template v-slot:modal-footer>&nbsp;</template>
                      </b-modal>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="preloader" v-if="showPreloader">
              <div class="spinner-border spinner-theme_default text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import { permissions } from '@mocks/permissions'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import TableForHoursTrackingReport from '@components/tables/TableForHoursTrackingReport'
import TableUserItem from '@components/tables/TableUserItem'
import FrontFilterMixin from '@/mixins/FrontFilterMixin'

const moment = extendMoment(Moment)

export default {
  components: {
    PageHeader,
    Filters,
    TableForHoursTrackingReport,
    TableUserItem
  },
  mixins: [ FrontFilterMixin ],
  data () {
    return {
      permissions,
      isDataPageLoading: false,
      currentWeek: 2,
      dataChangedMarker: 0,
      week: {
        date_yw: null,
        start: null,
        end: null
      },
      reportData: {},
      filter: {
        fields: {
          'users': {
            type: 'multiselect',
            name: 'users',
            label: 'Select user',
            class: 'col-md-3',
            valueField: 'jira_user_name',
            selectLabel: 'label',
            options: [],
            value: []
          },
          'users_roles': {
            type: 'multiselect',
            name: 'users_roles',
            label: 'Select role',
            class: 'col-md-2',
            valueField: 'name',
            selectLabel: 'display_name',
            options: [],
            value: []
          }
        }
      },
      filteredUsers: [],
      fieldsPeople: [
        {
          key: 'name',
          label: 'Specialist',
          sortable: true
        }
      ],
      showPreloader: false,
      reportsByUsers: [],
      reportsByProject: [],
      reportsByIssues: [],
      workingDays: {},
      totalSpentTime: []

    }
  },
  created () {
    (async () => {
      this.isDataPageLoading = true
      this.isShowFilter = false
      this.getDataWeek()
      Promise.all([
        this.fetchHoursTrackingReport(),
        this.$api.users.getAllUsers()
      ])
        .then(response => {
          this.setAllOptionsFilter()
        })
        .catch(e => {})
        .finally(() => {
          this.isDataPageLoading = false
        })
    })()
  },
  computed: {
    ...mapGetters({
      getUserRoles: 'getRoles'
    }),
    dateYW () {
      return moment(this.week.start).format('YYYY-WW')
    },
    allUsers () {
      return this.$store.getters.getAllUsers || []
    },
    getMembers () {
      if (!this.reportData.members) {
        return []
      }
      const members = cloneDeep(this.reportData.members)
      return Object.values(members)
    },
    getManagers () {
      if (!this.reportData.managers) {
        return []
      }
      return Object.values(this.reportData.managers).map(managerData => {
        const item = {
          id: managerData.user.id,
          name: managerData.user.name,
          logged_hours: managerData.logged_hours,
          members: []
        }
        const members = this.getMembersFilterData
        for (const i in members) {
          const memberJiraUserName = members[i].user.jira_user_name
          item.members.push({
            id: members[i].user.id,
            name: members[i].user.name,
            position: members[i].user.position,
            employment_type: members[i].user.employment_type,
            payment_type: members[i].user.payment_type,
            logged_hours: managerData.members[memberJiraUserName] ? managerData.members[memberJiraUserName].logged_hours : 0,
            commercial_hours: managerData.members[memberJiraUserName] ? managerData.members[memberJiraUserName].commercial_hours : 0
          })
        }
        return item
      })
    },
    getMemberFilterList () {
      return this.getMembers.map(item => item.user)
    },
    getMembersFilterData () {
      if (!this.filteredUsers.length && !this.filterState) {
        return this.getMembers
      }

      return this.filteredUsers || []
    },
    getTotalData () {
      if (!this.reportData.managers) {
        return []
      }
      // Trigger recompute
      if (this.dataChangedMarker) {}

      const total = this.getManagers.reduce((total, manager) => {
        for (const id in manager.members) {
          if (total[id] === undefined) {
            const memberName = manager.members[id].name
            total[id] = {
              id: manager.members[id].id,
              total_wh: this.getMemberByName(memberName).work_hours,
              total_lh: 0,
              total_ch: 0
            }
          }
          total[id].total_lh += parseFloat(manager.members[id].logged_hours)
          total[id].total_ch += parseFloat(manager.members[id].commercial_hours)
        }
        return total
      }, [])

      return total
    }
  },
  methods: {
    getMemberByName (name) {
      return this.getMembers.find(user => user.user.name === name)
    },
    setAllOptionsFilter () {
      this.filter.fields.users.options = this.getMemberFilterList
      this.filter.fields.users_roles.options = [
        {
          display_name: 'All',
          name: 'all'
        },
        ...this.getUserRoles
      ]
    },
    showCreateModal () {
      this.createModal.show = true
    },
    setFilterData (data) {
      const filterByUser = data.users.value
      const filterByUserRole = data.users_roles.value
      let users = []

      this.checkFilters(data)

      if (filterByUser.length) {
        users = this.usersFilter(this.getMembers, filterByUser)
      } else {
        users = [...this.getMembers]
      }

      if (filterByUserRole.length) {
        users = this.rolesFilter(users, filterByUserRole)
      }

      this.filteredUsers = users
    },
    getDataWeek () {
      this.week.start = moment().subtract(this.currentWeek, 'weeks').startOf('isoWeek')._d
      this.week.end = moment().subtract(this.currentWeek, 'weeks').endOf('isoWeek')._d
      this.week.date_yw = this.dateYW
    },
    fetchHoursTrackingReport () {
      this.isDataPageLoading = true
      return new Promise((resolve, reject) => {
        this.axios
          .post('/api/finances/reports/hours-tracking', {
            date_yw: this.dateYW
          }, {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          })
          .then(({ data }) => {
            this.reportData = data
            resolve(true)
          })
          .catch((error) => {
            this.errorNotifications(error)
            reject(error)
          })
          .finally(() => {
            this.isDataPageLoading = false
          })
      })
    },
    changeCurrentWeek (week) {
      if (week === 'next' && this.currentWeek !== 0) {
        this.currentWeek -= 1
      }
      if (week === 'prev') {
        this.currentWeek += 1
      }
      this.getDataWeek()
      this.fetchHoursTrackingReport()
      this.totalSpentTime = []
    },
    dataChanged () {
      this.dataChangedMarker++
    },
    getReport (fields) {
      this.showPreloader = true
      this.axios
        .post(
          '/api/report/logTime',
          fields,
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then(response => {
          this.showPreloader = false
          if (response.status === 200) {
            this.totalSpentTime = Object.values(response.data.total_spent_time)
            this.reportsByUsers = Object.values(response.data.users)
            this.reportsByProject = Object.values(response.data.projects)
            this.reportsByIssues = Object.values(response.data.issues)
            this.workingDays = response.data.working_days
          }
          this.$forceUpdate()
        })
        .catch(err => {
          this.showPreloader = false
          console.log(err)
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
    },
    createUserTooltip (report) {
      let message = `${report.user.name || ''} <br/> ${report.user.position || ''} <br/> ${report.user.employment_type.label || ''}/${report.user.payment_type || ''} <br/> Total: ${report.dates.total.spent_time || ''}`
      return `<div class="text-center" style="font-size: 12px;">${message}</div>`
    },
    getReportDateAttribute (report, date, attr) {
      return report.dates[date] !== undefined ? report.dates[date][attr] : null
    },
    isSickOrVacationDay (userName, date) {
      return this.isSickDay(userName, date) || this.isVacationDay(userName, date)
    },
    isSickDay (userName, date) {
      return this.getWorkingDay(userName, date) === 's'
    },
    getWorkingDay (jiraUserName, date) {
      const userDays = this.workingDays[jiraUserName]
      if (userDays && userDays[date]) {
        return userDays[date]
      }
      return '-'
    },
    isVacationDay (userName, date) {
      return this.getWorkingDay(userName, date) === 'v'
    },
    isWorkingDay (userName, date) {
      return (['', 'x', 'rx'].indexOf(this.getWorkingDay(userName, date)) !== -1)
    },
    isPartTimeDay (report, date) {
      return this.getReportDateAttribute(report, date, 'spent_time_seconds') < 28800
    },
    getStringFromStartEndSpentTime (arr) {
      if (!arr || !arr.length) return null

      let title = ''

      arr.forEach(item => {
        let oneTime = `Start: ${item.start_time} - End: ${item.end_time}\n`
        title += oneTime
      })

      return title
    },
    getDayTypeName (report, date) {
      let name = ''
      const userName = report.user.jira_user_name
      if (this.getWorkingDay(userName, date) === 'x') {
        name = 'Working day'
        if (this.isPartTimeDay(report, date)) {
          name += ' (less than 8 hours logged)'
        }
      } else if (this.getWorkingDay(userName, date) === 'rx') {
        name = 'Remote'
      } else if (this.getWorkingDay(userName, date) === 'w') {
        name = 'Weekend'
      } else if (this.getWorkingDay(userName, date) === 'h') {
        name = 'Holiday'
      } else if (this.getWorkingDay(userName, date) === 'v') {
        name = 'Vacation'
      } else if (this.getWorkingDay(userName, date) === 's') {
        name = 'Sick day'
      }
      return name
    },
    checkEmpty (arr) {
      if (arr && arr.length) {
        return true
      }
      return false
    },
    isReportedDay (report, date) {
      return this.getReportDateAttribute(report, date, 'is_reported') || this.isSickOrVacationDay(report.user.jira_user_name, date)
    },
    isCommentedDay (report, date) {
      return this.getReportDateAttribute(report, date, 'is_commented')
    }
  }

}
</script>

<style scoped lang="scss">

  .cursor-pointer {
    cursor: pointer;
  }

.spent-time{
  color: $fontColor2;
}

.working-day-w .spent-time,
.working-day-h .spent-time {
  background-color: #e2e7ee;
  color: #7489a9;
}

.working-day-rx .spent-time {
  background-color: #c6c5fb;
  color: #7489a9;
}

.working-day-v .spent-time,
.working-day-nv .spent-time {
  background-color: #b6d7a8;
  color: #7489a9;
}

.working-day-s .spent-time,
.working-day-ns .spent-time {
  background-color: #e3b2ed;
  color: #7489a9;
}

.working-day-x .spent-time {
  background-color: #fff;
  color: #7489a9;
}

.working-day-part-time .spent-time {
  background-color: #FFC0C7;
  color: #7489a9;
}

.spent-time{
  display: flex;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
}

table#table-transition {
  transition: transform 1s;
}
.card {
  overflow-x: scroll;
}
.block-loader {
  height: 85px;
}
.log_time_head {
  display: inline-block;
}
.table-fixed {
  display: block;
  height: 500px;
  overflow: auto;
}
/*thead,*/
/*tbody tr {*/
/*  display: table;*/
/*  overflow: "scroll";*/
/*  width: 100%;*/
/*  table-layout: fixed;*/
/*}*/

.th-name {
  width: 180px;
}

.th-else {
  width: 70px;
  text-align: center;
}

tbody td,
th {
  width: 70px;
  padding: 5px;
  border: 1px solid lightgray;
}

.booking-user-name{
  font-size: 13px;
  color: $tableTextHeadColor2;
  margin-bottom: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.booking-user-position{
  font-size: 11px;
  color: $tableTextHeadColor;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>
